import React from 'react';
import { useTranslation } from 'react-i18next';

// zones: string[] (fournies par l'orga via le back) | value | onSelect
export const ZoneSelector = ({ zones = [], value, onSelect }) => {
    const { t } = useTranslation();

    return (
        <div>
            <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-2.5 flex items-center gap-1.5">
                <span>📍</span> {t('profiling.zone.label', "D'où viens-tu ?")}
            </p>
            <div className="grid grid-cols-2 gap-2">
                {zones.map((zone) => {
                    const selected = value === zone;
                    return (
                        <button
                            key={zone}
                            type="button"
                            onClick={() => onSelect(zone)}
                            className={`py-3 rounded-xl border text-sm font-bold transition-all active:scale-95 ${
                                selected
                                    ? 'bg-action-green border-action-green text-white shadow-[0_6px_20px_-8px_rgba(16,185,129,0.6)]'
                                    : 'bg-white/5 border-white/10 text-gray-300 hover:bg-white/10 hover:border-white/20'
                            }`}
                        >
                            {t(`profiling.zone.options.${zone}`, zone)}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
